import React, { useState, useEffect } from 'react';
import './ContentForm.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { deleteContentApi, getContentApi } from '../../services/educationService';
import ReactQuill from 'react-quill';
import "react-quill/dist/quill.snow.css";
import { apiUrl, PORT } from "../../../environment";
import CustomAudioPlayer from './CustomAudioPlayer';
import editicon from "../../../images/edit-icon.svg";
import binicon from "../../../images/bin-icon.svg";

import { Button } from 'react-bootstrap';
import DeleteModel from '../model/DeleteModel';


const ContentForm = ({ weekId, day, weekNumber, onClose, onSave, contents = [], onDeleteContent }) => {
  const [activeTab, setActiveTab] = useState('view');
  const [isEditing, setIsEditing] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  // const [isAudioVisible, setIsAudioVisible] = useState(true);
  // Single useState for form data
  const [formData, setFormData] = useState({
    type: 'audio',
    title: '',
    description: '',
    content: '',
    audioFile: null,
    videoFile: null,
    contentId: null, // For editing existing content
  });

  const [contentData, setContentData] = useState([]);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [deleteContentData, setDeleteContentData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  // Reset form
  const resetForm = () => {
    setIsEditing(false);
    setEditIndex(null);
    setFormData({
      type: 'audio',
      title: '',
      description: '',
      content: '',
      audioFile: null,
      contentId: null, // Reset contentId
    });
  };

  // Edit existing content
  const handleEditContent = (item, index) => {
    setIsEditing(true);
    setEditIndex(index);
    setActiveTab('add');
    setFormData({
      type: item.type,
      title: item.title || '',
      description: item.description || '',
      content: item.textContent || '',
      audioFile: item.audioUrl || null,
      contentId: item._id
    });
  };

  // Save or update
  const handleSave = async () => {
    // Validate required fields
    if (!formData.title || formData.title.trim() === '') {
      return;
    }

    if (formData.type === 'text' && (!formData.content || formData.content.trim() === '')) {
      return;
    }

    // For audio type, allow existing audioFile (string URL when editing) or new file upload
    if (formData.type === 'audio' && !formData.audioFile && !isEditing) {
      return;
    }

    setIsLoading(true);

    try {
      const payload = {
        type: formData.type,
        title: formData.title,
        description: formData.description,
        contentId: formData.contentId,
        ...(formData.type === 'text' ? { textContent: formData.content } : { audio: formData.audioFile }),
      };

      const formPayload = new FormData();

      formPayload.append('type', formData.type);
      formPayload.append('title', formData.title);
      formPayload.append('description', formData.description);
      formPayload.append('contentId', formData.contentId || '');
      formPayload.append('weekId', weekId);
      formPayload.append('dayId', day?._id || '');

      if (formData.type === 'text') {
        formPayload.append('textContent', formData.content);
      } else if (formData.type === 'audio' && formData.audioFile) {
        // Only append audio file if it's a File object (new upload), not a string (existing URL)
        if (formData.audioFile instanceof File) {
          formPayload.append('audio', formData.audioFile);
        }
      } else if (formData.type === 'video' && formData.videoFile) {
        if (formData.videoFile instanceof File) {
          formPayload.append('video', formData.videoFile);
        }
      }

      await onSave(formPayload, isEditing ? editIndex : null); // send index if editing
      setActiveTab('view');
      fetchContent();
      resetForm();
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  // Handle input changes for form fields
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle file input change
  const handleFileChange = (e) => {
    // setIsAudioVisible(true);
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.files[0],
    }));
    // setIsAudioVisible(false);
  };

  const fetchContent = async () => {
    const response = await getContentApi(weekId, day?._id);

    setContentData(response?.data || []);
  };

  const handleTextEditorChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      content: value,
    }));
  };

  // delete content
  const handleDeleteContent = async (content) => {
    try {
      const response = await deleteContentApi(deleteContentData._id);
      if (response?.status === 'SUCCESS') {
        // fetchContent();
        setContentData(prev => ({
          ...prev,
          contents: prev.contents.filter(item => item._id !== deleteContentData._id),
        }));

        onDeleteContent({ ...deleteContentData, dayId: day?._id, weekId });

      }
    } catch (error) {
    }
  }
  const deleteContent = (content) => {
    setDeleteContentData(content);
    setDeleteModalShow(true)
  };


  useEffect(() => {
    // Reset form when modal opens
    if (activeTab === 'view') {
      fetchContent();
    }
  }, [weekId, day]);

  return (
    <div className="content-form-overlay">
      <div className="modal-dialog modal-lg modal-content p-4 rounded-3 shadow-sm content-form-modal">
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center mb-2">
          <div>
            <h5 className="fw-bold m-0">Day {day?.dayNumber} - Week {weekNumber}</h5>
            <small className="text-muted">{contentData?.description}</small>
          </div>
          <button className="btn-close" onClick={onClose}></button>
        </div>

        {/* Tabs */}
        <div className="d-flex justify-content-between align-items-center mb-3 px-1">
          <div className="nav nav-pills gap-2">
            <div className="graph-btns tabs">
              <button
                className={activeTab === 'view' ? 'active' : ''}
                onClick={() => {
                  setActiveTab('view');
                  resetForm();
                }}
              >
                View Content
              </button>
              <button
                className={activeTab === 'add' ? 'active' : ''}
                onClick={() => {
                  setActiveTab('add');
                  resetForm();
                }}
              >
                Add Content
              </button>
            </div>
          </div>
        </div>

        {/* ========== VIEW CONTENT ========== */}
        {activeTab === 'view' && (
          <div className="p-4 bg-light border rounded scroll-box-content-form">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <span className="fw-semibold">Session Items: {contentData?.contents?.length}</span>
              {contentData?.contents?.length == 0 ? <span className="badge bg-info">No Content Found </span> : <span className="badge bg-success">Content Ready</span>}
            </div>

            {contentData?.contents?.map((item, index) => (
              <div
                key={index}
                className="bg-white p-3 mb-3 border rounded shadow-sm position-relative"
              >
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    {/* <span className="text-danger me-2">📎</span> */}
                    <strong>{item.title}</strong>
                    {item.description && <div className="text-muted small">{item.description}</div>}
                  </div>
                  <div className="text-end">
                    <span className="badge rounded-pill bg-light text-dark border me-2">{item?.type?.toUpperCase()}</span>
                    <button
                      className="btn btn-sm edit-content-btn"
                      title="Edit"
                      onClick={() => handleEditContent(item, index)}
                    >
                      <img src={editicon} alt="edit" />
                    </button>

                    <button
                      // onClick={() => handleDeleteContent(item)}
                      onClick={() => deleteContent(item)}

                      className="btn edit-btn week-delete-btn"
                    >
                      {" "}
                      <img src={binicon} alt="delete" />
                    </button>
                  </div>
                </div>
                <div className="mt-3 p-2 bg-light rounded border small text-muted scroll-box-content" >
                  {/* {item.type === 'audio' ? '🔊 Audio content: ' : '📝 Text content: '} */}
                  <br />
                  {item.textContent && (
                    <p dangerouslySetInnerHTML={{ __html: item.textContent }}></p>
                  )}
                  {item?.audioUrl && (
                    <>
                      <CustomAudioPlayer src={item?.audioUrl} />
                      {/* <p className='mt-2 mx-1'>{item?.audioUrl}</p> */}
                    </>
                  )
                  }
                  {item?.videoUrl &&
                    <div className="mt-3 p-2 bg-light rounded border small text-muted scroll-box-content" >
                      <br />
                      <>
                        <video width="100%" height="240" controls>
                          <source src={item?.videoUrl} type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </>
                    </div>
                  }
                </div>

              </div>
            ))}
          </div>
        )}

        {/* ========== ADD/EDIT CONTENT ========== */}
        {activeTab === 'add' && (
          <div className="p-4 bg-light border rounded scroll-box-content-form">
            <h6 className="fw-semibold mb-2">
              {isEditing ? 'Edit Content' : 'Add New Content'}
            </h6>

            <div className="btn-group mb-2 mt-0" role="group">
              <div className="graph-btns tabs">
                <button
                  className={formData.type === 'text' ? 'active' : ''}
                  onClick={() => setFormData((prev) => ({ ...prev, type: 'text' }))}
                >
                  Text
                </button>
                <button
                  className={formData.type === 'audio' ? 'active' : ''}
                  onClick={() => setFormData((prev) => ({ ...prev, type: 'audio' }))}
                >
                  Audio
                </button>
                <button
                  className={formData.type === 'video' ? 'active' : ''}
                  onClick={() => setFormData((prev) => ({ ...prev, type: 'video' }))}
                >
                  Video
                </button>
              </div>
            </div>

            <div className="mb-3">
              <label className="form-label">Title</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter content title"
                name="title"
                value={formData.title}
                onChange={handleInputChange}
              />
            </div>

            {/* <div className="mb-3">
              <label className="form-label">Description (Optional)</label>
              <input
                type="text"
                className="form-control"
                placeholder="Brief description"
                name="description"
                value={formData.description}
                onChange={handleInputChange}
              />
            </div> */}

            {formData.type === 'text' ? (
              <div className="mb-3">
                <label className="form-label">Content</label>
                <ReactQuill
                  style={{ height: "200px", color: "#6B7280" }}
                  className="mb-5"
                  placeholder="Enter detail descriptions."
                  name="content"
                  value={formData.content}
                  onChange={(value) => handleTextEditorChange(value)}

                  modules={{
                    toolbar: [
                      [{ header: [1, 2, 3, false] }],
                      ["bold", "italic", "underline"],
                      [{ list: "ordered" }, { list: "bullet" }],
                      ["link", "image", "video"], // Insert options
                      [{ align: [] }],
                      ["clean"],
                      [{ color: [] }],
                    ],
                  }}
                />
              </div>
            ) : formData.type === 'audio' ? (
              <div className="mb-3">
                <label className="form-label">Upload Audio File</label>
                <input
                  type="file"
                  className="form-control"
                  accept="audio/*"
                  name='audioFile'
                  onChange={handleFileChange}
                />
                {/* {isAudioVisible && formData?.audioFile && ( */}
                {/* <> */}
                {/* <small className="text-muted d-block mt-1">Selected: {formData?.audioFile?.name || formData?.audioFile || 'No file selected'}</small> */}
                {/* <audio controls>
                        <source src={`${apiUrl}${PORT}/user-service/getaudio/${formData?.audioFile}`} type="audio/mpeg" />
                        Your browser does not support the audio element.
                      </audio> */
                }
                {/* <CustomAudioPlayer src={`${apiUrl}${PORT}/user-service/getaudio/${formData?.audioFile?.name || formData?.audioFile}`} /> */}
                {/* </> */}
                {/* )} */}
              </div>
            ) : formData.type === 'video' && (
              <div className="mb-3">
                <label className="form-label">Upload Video File</label>
                <input
                  type="file"
                  className="form-control"
                  name='videoFile'
                  accept="video/*"
                  onChange={handleFileChange}
                />
              </div>
            )}
            <div className="d-flex justify-content-end  gap-2">
              <Button
                onClick={() => setActiveTab('view')}
                className="btn outlined-btn"
                disabled={isLoading}
              >
                Cancel
              </Button>
              <Button
                onClick={handleSave}
                className="filled-btn"
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    {isEditing ? 'Updating...' : 'Saving...'}
                  </>
                ) : (
                  isEditing ? 'Update Content' : 'Save Content'
                )}
              </Button>

            </div>
          </div>

        )}
        <DeleteModel setDeleteModelShow={setDeleteModalShow} deleteModelShow={deleteModalShow} handelDelete={handleDeleteContent} deletedData={deleteContentData} type="Content" />

      </div>
    </div>
  );
};

export default ContentForm;
